import { render } from "./tableData.vue?vue&type=template&id=478fca46&ts=true"
import script from "./tableData.vue?vue&type=script&lang=ts"
export * from "./tableData.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__